import { Scene } from "three"
import createSharedCachedFactory from "../../../rx/memo/createSharedCachedFactory"

const useMainScene = createSharedCachedFactory((
  // engine: Engine
) => {
  const scene = new Scene()
  return scene
})

export default useMainScene
